<template>
    <div class="page bg-white">
        <div class="flex_b_c">
            <div>
                <el-cascader class="m_r1"
                        v-model="cityId"
                        :options="cityOpt" :props="{ value: 'id', label: 'name' }"
                        size="small" @change="changeCity"></el-cascader>
                <el-select v-model="hospitalId" placeholder="请选择" size="small" @change="changeHospital">
                    <el-option
                            v-for="item in hospitalOpt"
                            :key="item.id"
                            :label="item.hospitalName"
                            :value="item.id">
                    </el-option>
                </el-select>
            </div>
            <div>
                <el-button type="primary" size="small" icon="el-icon-plus" @click="add()">新建</el-button>
                <el-button type="danger"   size="small" icon="el-icon-delete" @click="del()"
                           :disabled="dataListSelections.length <= 0" plain>删除
                </el-button>
            </div>
        </div>
        <el-table
                :data="dataList"
                v-loading="loading"
                size="small"
                height="calc(100% - 80px)"
                @selection-change="selectionChangeHandle"
                class="table">
            <el-table-column
                    type="selection"
                    width="50">
            </el-table-column>
            <el-table-column prop="departmentName" label="科室名称" show-overflow-tooltip></el-table-column>
            <el-table-column prop="money" label="科室默认金额" show-overflow-tooltip></el-table-column>
            <!--<el-table-column prop="createUser" label="创建人" show-overflow-tooltip></el-table-column>
            <el-table-column prop="createTime" label="创建时间" show-overflow-tooltip></el-table-column>
            <el-table-column prop="updateTime" label="修改时间" show-overflow-tooltip></el-table-column>
            <el-table-column prop="updateUser" label="修改人" show-overflow-tooltip></el-table-column>-->
            <el-table-column
                    fixed="right"
                    width="200"
                    label="操作">
                <template slot-scope="scope">
                    <el-button type="text" size="small"
                               icon="el-icon-view" @click="view(scope.row)">查看
                    </el-button>
                    <el-button type="text" size="small"
                               icon="el-icon-edit" @click="edit(scope.row)">修改
                    </el-button>
                    <el-button type="text" size="small"
                               icon="el-icon-delete" @click="del([scope.row.id])">删除
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
                @size-change="sizeChangeHandle"
                @current-change="currentChangeHandle"
                :current-page="pageNo"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="pageSize"
                :total="total"
                background=""
                layout="total, sizes, prev, pager, next, jumper">
        </el-pagination>
        <OfficeForm ref="officeForm" @refreshDataList="refreshList"></OfficeForm>
    </div>
</template>
<script>
    import OfficeForm from './officeForm'
    export default {
        components: {
            OfficeForm
        },
        data() {
            return {
                cityId: ['1277876432646750210', '738049426362204160'],
                cityOpt: [],
                hospitalId: '',
                hospitalOpt: [],
                dataList: [],
                pageNo: 1,
                pageSize: 10,
                total: 0,
                loading: false,
                dataListSelections: [],
            }
        },
        activated() {
            this.getCity()
        },
        methods: {
            // 获取城市
            getCity() {
                this.loading = true
                this.$axios(this.api.order.getSysArea).then(res => {
                    if (res.status) {
                        this.cityOpt = res.data
                        this.cityOpt[0].children.map(item => {
                            if(!item.children.length) {
                                delete item.children;
                            }
                        })
                        this.getHospital()
                    }
                })
            },
            // 获取医院
            getHospital() {
                this.$axios(this.api.order.getMingenHospitalByCityId, {cityId: this.cityId[1]}).then(res => {
                    if (res.status) {
                        this.hospitalOpt = res.data
                        if(this.hospitalOpt.length) {
                            this.hospitalId = this.hospitalOpt[0].id
                        }
                        this.refreshList(1)
                    }
                })
            },
            changeCity() {
                this.hospitalId = ''
                this.getHospital()
            },
            changeHospital() {
                this.refreshList(1)
            },
            // 获取数据列表
            refreshList(type) {
                if(type == 1) {
                    this.current = 1
                }
                this.loading = true
                this.$axios(this.api.order.departmentList, {
                    current: this.pageNo,
                    size: this.pageSize,
                    hospitalId: this.hospitalId
                }, 'get').then(data => {
                    if (data.status) {
                        this.dataList = data.data.records
                        this.total = parseInt(data.data.total)
                        this.loading = false
                    }
                })
            },
            // 新增
            add() {
                this.$refs.officeForm.init('add', '')
            },
            // 修改
            edit(row) {
                let val = JSON.parse(JSON.stringify(row))
                val.cityId = this.cityId
                val.hospitalId = this.hospitalId
                this.$refs.officeForm.init('edit', val)
            },
            // 查看
            view(row) {
                let val = JSON.parse(JSON.stringify(row))
                val.cityId = this.cityId
                val.hospitalId = this.hospitalId
                this.$refs.officeForm.init('view', val)
            },
            // 删除
            del (id) {
                let ids = id || this.dataListSelections.map(item => {
                    return item.id
                })
                this.$confirm(`确定删除所选项吗?`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.loading = true
                    this.$axios(this.api.order.departmentRemove, ids, 'post').then(data => {
                        this.loading = false
                        if (data.status) {
                            this.$message.success(data.msg)
                            this.refreshList()
                        } else {
                            this.$message.error(data.msg)
                        }
                    })
                })
            },
            // 多选
            selectionChangeHandle (val) {
                this.dataListSelections = val
            },
            // 每页数
            sizeChangeHandle(val) {
                this.pageSize = val
                this.pageNo = 1
                this.refreshList()
            },
            // 当前页
            currentChangeHandle(val) {
                this.pageNo = val
                this.refreshList()
            },

        }
    }
</script>
